import { RequestBody } from "./RequestBody"
export class UpdatePassword extends RequestBody{
    emailIdOrMobileNo:string
    newPassword:string
    oldPassword:string
}